import React, { useEffect, useState } from "react";
import "./componentStyles/PartTimeEmployeeSearchResults.css";
import EmployeeDetailCard from "./EmployeeDetailCard";
import api from "../services/api";

export default function PartTimeEmployeeSearchResults({ query, openPuantajUnit }) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [terminating, setTerminating] = useState(false);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      setLoading(false);
      return;
    }
    let active = true;
    setLoading(true);
    const timeoutId = setTimeout(async () => {
      try {
        const res = await api.get(`/admin/puantaj/employees/search?q=${encodeURIComponent(query)}`);
        if (active) setResults(res.data?.data || []);
      } catch (err) {
        if (active) setResults([]);
      } finally {
        if (active) setLoading(false);
      }
    }, 300);
    return () => {
      active = false;
      clearTimeout(timeoutId);
    };
  }, [query]);

  const handleShowDetail = async (emp, e) => {
    e.stopPropagation();
    console.log("Detay isteniyor:", emp); // DEBUG
    
    if (!emp.applicationId) {
      console.error("applicationId bulunamadı!");
      alert("Bu öğrenci için detay bilgisi alınamıyor.");
      return;
    }
    
    setShowDetailModal(true);
    setDetailLoading(true);
    setSelectedEmployee(null);
    
    try {
      const endpoint = `/admin/puantaj/employee/${emp.applicationId}/detail`;
      console.log("API çağrısı yapılıyor:", endpoint); // DEBUG
      const res = await api.get(endpoint);
      console.log("API yanıtı:", res.data); // DEBUG
      setSelectedEmployee(res.data?.data || null);
    } catch (err) {
      console.error("Detay yüklenirken hata:", err);
      console.error("Hata detayı:", err.response?.data); // DEBUG
      alert("Detay bilgisi yüklenirken hata oluştu.");
      setSelectedEmployee(null);
    } finally {
      setDetailLoading(false);
    }
  };
  const handleCloseDetail = () => {
    setShowDetailModal(false);
    setSelectedEmployee(null);
  };


  const handleTerminate = async () => {
    if (!selectedEmployee?.applicationId) {
      alert("Application ID bulunamadı!");
      return;
    }

    const confirm = window.confirm(
      `${selectedEmployee.studentName} (${selectedEmployee.studentSicilNo}) için sigorta çıkışı verilecek.\n` +
      `Devam etmek istediğinize emin misiniz?`
    );

    if (!confirm) return;

    setTerminating(true);
    
    try {
      const res = await api.post(`/admin/puantaj/employee/${selectedEmployee.applicationId}/terminate`);
      
      if (res.data?.success) {
        alert("Sigorta çıkışı başarıyla verildi!");
        handleCloseDetail();
        // Arama sonuçlarını yenile
        if (query.trim()) {
          const searchRes = await api.get(`/admin/puantaj/employees/search?q=${encodeURIComponent(query)}`);
          setResults(searchRes.data?.data || []);
        }
      } else {
        alert(res.data?.message || "Sigorta çıkışı verilemedi.");
      }
    } catch (err) {
      console.error("Terminate error:", err);
      alert(err.response?.data?.message || "Sigorta çıkışı verilirken hata oluştu.");
    } finally {
      setTerminating(false);
    }
  };
  

  if (loading) {
    return <div className="ptes-empty">Aranıyor...</div>;
  }

  if (!results.length) {
    return (
      <div className="ptes-empty">
        <i className="fa-solid fa-user-graduate" style={{ marginRight: "8px" }}></i>
        Eşleşen öğrenci bulunamadı.
      </div>
    );
  }

  return (
    <>
      <div className="ptes-results-container">

        {results.map(emp => (
          <div
            key={emp._id}
            className="ptes-row"
            title="Birim puantajını aç"
          >
            <div className="ptes-row-header">
              <div className="ptes-row-main">
                {emp.studentName} 
                <span className="ptes-sicil">({emp.studentSicilNo})</span>
              </div>
                          <div className="ptes-row-meta">
              <span>
                <i className="fa-solid fa-building"></i>
                <b>Birim:</b> {emp.unitName} 
                <span className="ptes-meta-secondary">({emp.unitSicilNo})</span>
              </span>

            </div>
              <button
                className="ptes-detail-btn"
                onClick={(e) => handleShowDetail(emp, e)}
                title="Detayları Görüntüle"
              >
                Detay
              </button>
            </div>
            

          </div>
        ))}
      </div>

      {showDetailModal && (
        <div className="ptes-modal-overlay" onClick={handleCloseDetail}>
          <div className="ptes-modal-content" onClick={(e) => e.stopPropagation()}>
            <EmployeeDetailCard
              detail={selectedEmployee}
              loading={detailLoading}
              onClose={handleCloseDetail}
              onTerminate={handleTerminate}
              terminating={false}
            />
          </div>
        </div>
      )}
    </>
  );
}